// Mixins
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

export const tableMixins = {
	mixins: [ inputTextMixins ],
	data() {
		return {
			// table
			theads: [],
			tableContent: {
				tableData: [],
				paginationData: {
					totalCount: 0,
					page: 1,
					limit: 10,
					pageCount: 1
				}
			},
			// items per page
			limitDropdown: [10, 20, 50, 100],
			limit: 10,
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			// sorting
			sortBy: '',
			desc: false,
			columnsFilter: {}
		}
	},
	computed: {
		setFirstPrevDisabled() {
			return this.pageCount === 1 || this.page === 1 || this.page === 0;
		},
		setNextLastDisabled() {
			return this.pageCount === 1 || this.page === this.pageCount || this.page === 0;
		},
		paginationNumbers() {
			let pages = [];
			let pageLimit = 5;
			let upperLimit, lowerLimit;
	  
			if (this.tableContent.tableData.length > 0) {
				const total = this.tableContent.paginationData.pageCount;
				this.page = lowerLimit = upperLimit = Math.min(this.page === 0 ? 1 : this.page, total);
		
				// set upper and lower pages button
				for (let b = 1; b < pageLimit && b < total;) {
					if (lowerLimit > 1) {
						lowerLimit--;
						b++;
					}
					if (b < pageLimit && upperLimit < total) {
						upperLimit++;
						b++;
					}
				}

				// push pages to array for displaying after setting the pages selected
				for (let i = lowerLimit; i <= upperLimit; i++) {
					pages.push(i);
				}
		    } else {
				pages.push(1);
			}

			return pages;
		  }
	},
	watch: {
		tableContent: {
			immediate: true,
			deep: true,
			handler(newValue) {
				if (newValue) {
					// set pagination details upon table update
					this.setPaginationDetails();
				}
			}
		}
	},
	methods: {
		setPaginationDetails() {
			// set pagination details
			if (this.tableContent.paginationData !== undefined) {
				this.limit = this.tableContent.paginationData.limit;

				if (this.tableContent.paginationData.pageCount !== null) {

					this.pageCount = this.tableContent.paginationData.pageCount;
					this.totalCount = this.tableContent.paginationData.totalCount;
				}
			}
		},
		onPageSelected(action) {
			// determine the pagination action
			if (action === 'first') {
				this.page = 1;
			} else if (action === 'next') {
				this.page = this.page + 1;
			} else if (action === 'prev') {
				this.page = this.page - 1;
			} else if (action === 'last') {
				this.page = this.tableContent.paginationData.pageCount;
			}
		
			// update the table details upon page select
			this.onPageChange(null, this.page);
		},
		onPageChange(limit, page, numberSelected) {
			// do nothing if selected page is the same with the current page
			if (numberSelected && page === this.page) {
				return;
			}

			// set current page to 1 if items per page has changed else set the passed param value
			this.page = limit ? 1 : page;
		
			// update the items per page value
			if (limit) {
				this.limit = limit;
			}
		
			// update the table result page on pagination params
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc);
		},
		onSort(sortBy, alwaysAPISort) {
			if (this.tableContent.tableData.length > 1) {
				for (let th of this.theads) {
					if (th.sortLabel === sortBy) {
						th.isDesc = !th.isDesc;
						this.desc = th.isDesc;
					} else {
						th.isDesc = false;
					}
				}
				this.sortBy = sortBy;
				
				if (parseInt(this.totalCount) >= parseInt(this.limit) || alwaysAPISort) {
					// api sorting
					this.getTableContent(this.page, this.limit, this.sortBy, this.desc);
				} else {
					// ui sorting
					this.sortOnUI(this.desc);
				}
			}
		},
		sortOnUI(desc) {
			this.tableContent.tableData = this.tableContent.tableData.sort((a, b) => {
				const fieldA = a[this.sortBy] ? a[this.sortBy] : '';
				const fieldB = b[this.sortBy] ? b[this.sortBy] : '';
		
				if (fieldA) {
					// number sorting
					if (!isNaN(fieldA)) {
						return desc ? parseInt(fieldB) - parseInt(fieldA) : parseInt(fieldA) - parseInt(fieldB);
					// string sorting
					} else {
						if (desc) {
							return fieldA.toLowerCase() === fieldB.toLowerCase() ? 0 : -(fieldA.toLowerCase() > fieldB.toLowerCase()) || + 1;
						} else {
							return fieldA.toLowerCase() === fieldB.toLowerCase() ? 0 : +(fieldA.toLowerCase() > fieldB.toLowerCase()) || - 1;
						}
					}
				}

				return 0;
			});
		},
		onColumnFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = event.target.value;
				this.delayTyping(() => {
					this.getTableContent(this.page, this.limit, this.sortBy, this.desc, false);
				});
			}
		},
		// For V-Select in-column Filters
		onFilter(filterBy, value) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = value;
				this.getTableContent(this.page, this.limit, this.sortBy, this.desc);
			}
		},
		// For V-Select in-column Filters
		onDropdownFilter(filterBy, value) {
			if (filterBy) {
				this.columnsFilter[filterBy] = value;
				this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true);
			}
		},
		onColumnFilterDateRange(filterBy, event) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter['f_dateStartsAt'] = event[0];
				this.columnsFilter['f_dateEndsAt'] = event[1];
				this.delayTyping(() => {
					this.getTableContent(this.page, this.limit, this.sortBy, this.desc, false);
				});
			}
		},
	}
}